import {AxiosReadPayload} from '../../shared/service/axios-read-payload';
import {axiosReadHelper} from '../../shared/service/axios-read-helper';

class MetaDataService{
  async getPatientEncounterMetaData(){
    const readPayload: AxiosReadPayload = {
      url: `patient-encounter/v2/patient/encounter/metaData`,
    };
    return await axiosReadHelper(readPayload);
  }


  async getPaymentChannels(){
    const readPayload: AxiosReadPayload = {
      url: `payments/v3/payment-channel`,
    };
    return await axiosReadHelper(readPayload);
  }

}

export const metaDataService = new MetaDataService();